import { ICreditResponse } from 'shared';

import { CacheTags } from '../../types/cacheTags';
import { emptySplitApi } from '../baseApi';

export const creditsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchCredits: builder.query<ICreditResponse, { organisationId: string }>({
      query: ({ organisationId }) => ({
        url: `credits`,
        method: `GET`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      providesTags: [{
        type: CacheTags.Credits,
      }],
    }),
  }),
});

export const {
  useFetchCreditsQuery,
} = creditsApi;
